// @flow

import React                        from 'react';
import { Switch, Route, Redirect }  from 'react-router-dom';
import Login                        from './login';
import ResetPassword                from './resetPassword';
import ResetPasswordSuccess         from './resetPassword/success';
import NewPassword                  from './resetPassword/new';
import Confirmation                 from './confirmation/confirmation';
import ConfirmationSuccess          from './confirmation/success';
import Unlock                       from './unlock/unlock';
import Logout                       from './logout/logout';
import NotFound                     from 'components/common/notFound/notFound.js';

const Routes = () => (
  <Switch>
    <Route exact path='/session' render={() => (
      <Redirect to="/session/login" />
    )}/>

    <Route path='/session/login' component={Login} />

    <Route exact path='/session/confirmation' component={Confirmation} />
    <Route path='/session/confirmation/success' component={ConfirmationSuccess} />

    <Route exact path='/session/reset-password' component={ResetPassword} />
    <Route path='/session/reset-password/success' component={ResetPasswordSuccess} />
    <Route path='/session/reset-password/new' component={NewPassword} />

    <Route exact path='/session/unlock' component={Unlock} />

    <Route exact path='/session/logout' component={Logout} />

    <Route component={NotFound} />
  </Switch>
)

export default Routes;



// WEBPACK FOOTER //
// ./src/components/session/routes.js